<template>
  <div class="auth-wrapper px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
           <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
            width="250"
          />
        </b-link>

        <center>
          <b-card-title>
            <h2><b>Wawancara Online Seleksi Mahasiswa</b></h2>
          </b-card-title>
            <h3>{{ appName }} Fakultas Psikologi Universitas Indonesia</h3>
          <br><br>
        </center>
        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
        <center>
          <div style="width: 40%">
            <b-form
              class="auth-login-form mt-5"
              @submit.prevent
              style="width: 100%;"
            >

            <div class="mb-3">
              <center>
                <!-- <b-avatar
                  size="32"
                  :src="data.item.avatar"
                  :text="avatarText(data.item.name)"
                  :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                  title="Lihat Profil"
                /> -->
                <div class="d-flex justify-content-center">  
                  <b-avatar
                    size="80"
                    :text="respGetData.name.charAt(0)"
                    :variant="`light-primary`"
                    title="Picture"
                  />
                  <div class="mt-1 ml-1" style="text-align: left;">  
                    <h4>{{ respGetData.name }}</h4>
                    <div class="d-flex">  
                      <feather-icon icon="EditIcon" style="margin-right: 5px;" /><h5 class="mr-2"> Nomor Ujian : {{ respGetData.nomor_ujian }}</h5>
                      <feather-icon icon="MailIcon" style="margin-right: 5px;" /><h5> Email : {{ respGetData.email }}</h5>
                    </div>
                  </div>
                </div>
              </center>
            </div>

              <!-- email -->
              <b-form-group
                label-for="email"
                label="Email"
                style="text-align: left;"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="email"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="email@example.com"
                    autofocus
                  />
                <small class="text-danger">{{ errors[0] ? 'Silahkan isi email anda' : '' }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                  style="text-align: left;"
                >
                  Ingat Saya
                </b-form-checkbox>
              </b-form-group> -->

              

              <!-- submit button -->
              <b-button
                variant="primary"
                type="submit"
                block
                :disabled="loading == 1"
                @click="login()"
              >
                <center><b-spinner v-if="loading == 1" label="Spinning"></b-spinner></center>
                Verifikasi untuk mengisi form wawancara
              </b-button>
            </b-form>
          </div>
        </center>
        </validation-observer>

        <b-card-text class="text-center mt-2 mb-2">
          <!-- <span>Belum Verifikasi Akun? </span>
          <b-link :to="{name:'auth-register'}">
            <span>Verifikasi Sekarang</span>
          </b-link> -->
        </b-card-text>

      </b-card>
      <!-- /Login v1 -->

    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox, BImg, BSpinner, BAvatar,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import router from '@/router'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  Authlogin,
  setToken,
  setRefreshToken,
} from '@/connection-api/authentication'
import {
  resetAkun,
  getDataUserWawancara,
  loginPewawancara,
} from '@/connection-api/master'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BImg,
    vSelect,
    BSpinner,
    BAvatar,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      loading: 0,
      loadingShow: false,
      reset: {},
      username: '',
      password: '',
      status: '',
      required,
      email,
      sideImg: require('@/assets/images/logo/logo.png'),
      respGetData: {},
    }
  },
  mounted() {
    var data = {
      token: this.$route.params.token
    }
    getDataUserWawancara(data)
      .then(response => {
      if (response.data.success == true) {
        this.respGetData = response.data.data.check_user
      }
      })
      .catch(error => console.log(error));
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    simpanResetAkun()
    {
      this.loadingShow = true
      resetAkun(this.reset)
      .then(response => {
      if (response.data.success == true) {
        this.loadingShow = false
       this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Anda telah berhasil reset akun Ujian Online. Silahkan login menggunakan kredensial baru anda.',
          },
        })
        this.$bvModal.hide('bv-modal-reset-user')
      } else {
        this.loadingShow = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: response.data.message,
          },
        })
        this.$bvModal.hide('bv-modal-reset-user')
      }
      })
      .catch(error => console.log(error));
    },
    login() {
      this.loading = 1
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          loginPewawancara({
            email: this.email,
            token: this.$route.params.token,
            application_token: this.applicationToken,
            query: router.currentRoute.query,
            token_firebase: localStorage.getItem('tokenFirebase'),
            login_sebagai: this.login_sebagai,
          })
            .then(response => {
              if (response.data.success == false) {
                this.loading = 0
                this.$swal({
                  title: 'Wawancara',
                  html: `${response.data.status.message}`,
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              } else {
                this.loading = 0
                this.$swal({
                  title: 'Wawancara',
                  html: `${response.data.status.message}`,
                  icon: 'success',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
                
                const { member, urlCallback } = response.data.data
                setToken(response.data.data.accessToken)
                setRefreshToken(response.data.data.refreshToken)

                localStorage.setItem('token', this.$route.params.token)
                localStorage.setItem('userData', JSON.stringify(member))
                localStorage.setItem('tipe', 'wawancara')
                this.$ability.update(member.ability)
                if (urlCallback === '') {
                  this.$router.push(`/form-pewawancara/wawancara/${this.$route.params.token}`)
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Selamat Datang ${member.fullName || member.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: 'Anda telah berhasil masuk PPDB Online. Sekarang Anda bisa mulai menjelajah!',
                        },
                      })
                    })
                } else {
                  localStorage.setItem('urlCallback', urlCallback)
                  window.location.href = urlCallback
                }
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
